import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const SPACING_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Spacing.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .number('line', 'Entity.Spacing.Line')
    .required()
    .decimal(3,4)
    .build(),
  FieldBuilder
    .number('betweenLine', 'Entity.Spacing.BetweenLine')
    .required()
    .decimal(2,10)
    .build(),
  FieldBuilder
    .checkbox('isVisible', 'Entity.Spacing.IsVisible')
    .build(),
];

export const SPACING_CONFIG = {
  entityName: 'Spacing',
  localizationKey: 'Planning::Entity.Spacing',
  fields: SPACING_FIELDS,
  permission: 'PlanningOperation.Spacings',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.OperationPlanning + MENU_NAME_SUFFIX,
};
